var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',{staticClass:"doc_list_title",style:(_vm.styles)},[_vm._v(" "+_vm._s(_vm.subTitle)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }